class StarPicker extends Component {
    /** {HTMLInputElement} value */
    valueInput;
    /** {NodeListOf<HTMLSpanElement>} */
    stars;

    constructor(el) {
        super(el);
        this.valueInput = this.$el.querySelector('[data-value-input]');
        this.stars = this.$el.querySelectorAll('[data-star-value]');
        this.activeStarCssClass = "is-selected";
        this.addEventListeners();
        this.reloadValueFromInput();
    }

    /**
     * @param {number} value
     */
    updateInputValue(value) {
        this.valueInput.value = value;
    }

    reloadValueFromInput() {
        const currentValue = this.valueInput.value;
        this.stars.forEach(el => {
            const starValue = el.dataset.starValue;
            if (starValue > currentValue) {
                el.classList.remove(this.activeStarCssClass);
                return;
            }

            el.classList.add(this.activeStarCssClass);
        });
    }

    addEventListeners() {
        this.stars.forEach(el => {
            el.addEventListener("click", e => {
                const value = Number.parseInt(e.currentTarget.dataset.starValue ?? "0");
                this.updateInputValue(value);
                this.reloadValueFromInput();
            });
        });
    }

}